import React from 'react';
export function ImaginateSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#142014] relative overflow-hidden" data-id="element-67">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(200,230,201,0.08)_0,transparent_50%)]" data-id="element-68" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-69">
        <span className="text-6xl mb-8 block opacity-80" data-id="element-70">💭</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#c8e6c9] mb-12 uppercase tracking-widest" data-id="element-71">
          Imaginate esto:
        </h2>

        <div className="space-y-6 font-heading text-4xl md:text-6xl font-black" data-id="element-72">
          <p className="text-[#d4d0c4] transform transition-all hover:scale-105 cursor-default" data-id="element-73">
            Recibís la bocha.
          </p>
          <p className="text-[#faf5e8] transform transition-all hover:scale-105 cursor-default" data-id="element-74">
            No pensás. Actuás.
          </p>
          <p className="text-[#c8e6c9] transform transition-all hover:scale-105 cursor-default" data-id="element-75">
            Y ganás la jugada.
          </p>
        </div>
      </div>
    </section>;
}